import { FormHTMLAttributes, useCallback } from "react";
import {
  FieldValues,
  SubmitErrorHandler,
  SubmitHandler,
  UseFormReturn,
} from "react-hook-form";
import { focusElement } from "../../utils";

interface FormProps<T extends FieldValues>
  extends FormHTMLAttributes<HTMLFormElement> {
  onValidSubmit: SubmitHandler<T>;
  onInvalidSubmit?: SubmitErrorHandler<T>;
  dataTestId?: string;
  formData: UseFormReturn<T>;
}

export const Form = <T extends FieldValues>({
  onValidSubmit,
  onInvalidSubmit,
  dataTestId = "form",
  children,
  formData,
  ...props
}: FormProps<T>) => {
  const { handleSubmit } = formData;

  const handleInvalidSubmit: SubmitErrorHandler<T> = useCallback(
    (args) => {
      onInvalidSubmit?.(args);
      setTimeout(() => {
        focusElement(
          document.querySelector(
            "[class*=error] input, [class*=error] textarea",
          ),
        );
      }, 0);
    },
    [onInvalidSubmit],
  );

  return (
    <form
      {...props}
      data-testid={dataTestId}
      onSubmit={(event) => {
        handleSubmit(onValidSubmit, handleInvalidSubmit)(event);
      }}
    >
      {children}
    </form>
  );
};
